import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './CarouselBanner.css'; // Tus estilos personalizados, si los necesitas

const CarouselBanner = ({ imgSrcs }) => {
    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        
        // nextArrow: <SampleNextArrow />,
        // prevArrow: <SamplePrevArrow />
        nextArrow: null,
        prevArrow: null
    };

    return (
        <div className="carousel-container">
            <Slider {...settings}>
                {imgSrcs.map((src, index) => (
                    <div key={index}>
                        <img src={src} alt={`Slide ${index + 1}`} />
                    </div>
                ))}
            </Slider>
        </div>
    );
};

// Puedes personalizar las flechas como componentes de React
function SampleNextArrow(props) {
    const { className, style, onClick } = props;
    return (
        <div
            className={className}
            style={{ ...style, display: "block", background: "black" }}
            onClick={onClick}
        />
    );
}

function SamplePrevArrow(props) {
    const { className, style, onClick } = props;
    return (
        <div
            className={className}
            style={{ ...style, display: "block", background: "black" }}
            onClick={onClick}
        />
    );
}

export default CarouselBanner;

